import { render, staticRenderFns } from "./geneChildFx.vue?vue&type=template&id=bec644fe&scoped=true"
import script from "./geneChildFx.vue?vue&type=script&lang=js"
export * from "./geneChildFx.vue?vue&type=script&lang=js"
import style0 from "./geneChildFx.vue?vue&type=style&index=0&id=bec644fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec644fe",
  null
  
)

export default component.exports